import Vue from 'vue'
import Component from 'vue-class-component'
import statementStore from '../../store/statement/statement-store'
import authStore from '../../store/auth/auth-store'
import feedStore from '../../store/feed/feed-store'
import { StatementSearchForm } from '../../model/search/search-query'
import { IUser } from '@/model/user';

@Component({
  name: 'statement-search',
})
export default class StatementSearch extends Vue {
  mounted (): void {
    this.$store.subscribe((mutation, state) => {
      console.log('StatementSearch mutation: type = %j', mutation.type)
      if (mutation.type === 'user/setIsFollowing') {
        const form: StatementSearchForm = this.statementSearchForm
        if (form.createdByFollowing || form.jybedByFollowing) {
          console.log('StatementSearch mutation: ferching statements')
          statementStore.dispatchFetchStatements()
        }
      }
    })
  }

  get statementSearchForm () { return statementStore.state.statementSearchForm }

  get userFeed () { return feedStore.state.feedUser && !feedStore.state.isCurrent }

  get user () { return feedStore.state.feedUser }

  get isAuthenticated () { return authStore.isAuthenticated }

  get userFirstName () { 
    const user = feedStore.state.feedUser as IUser
    if (!user) return null
    if(user.firstName) return user.firstName
    return (user.name as string).slice(0,(user.name as string).indexOf(' '))
  }

  created (): void {
  }

  protected addSearchTag (): void {
    statementStore.dispatchAddSearchTag()
  }

  protected removeSearchTag(tag: string): void {
    statementStore.dispatchRemoveSearchTag(tag)
  }

  protected toggleCreatedByUser (): void {
    statementStore.dispatchToggleCreatedByUser()
  }

  protected toggleCreatedByFollowing (): void {
    statementStore.dispatchToggleCreatedByFollowing()
  }

  protected toggleJybedByUser (): void {
    statementStore.dispatchToggleJybedByUser()
  }

  protected toggleJybedByFollowing (): void {
    statementStore.dispatchToggleJybedByFollowing()
  }

  protected toggleCreatedByMe (): void {
    statementStore.dispatchToggleCreatedByMe()
  }

  protected toggleJybedByMe (): void {
    statementStore.dispatchToggleJybedByMe()
  }

  protected toggleConsideredByMe (): void {
    statementStore.dispatchToggleConsideredByMe()
  }

  protected toggleIgnoredByMe (): void {
    statementStore.dispatchToggleIgnoredByMe()
  }

  protected toggleNotReactedByMe (): void {
    statementStore.dispatchToggleNotReactedByMe()
  }
}
